module.exports = __webpack_public_path__ + "img/pro-m-slider4.5c23e4b7.png";